import * as Popover from "@radix-ui/react-popover";
import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import iconQuestionMarkCircle from "../../../../img/icons/question-mark-circle.svg";
import iconXClose from "../../../../img/icons/x-close.svg";

import styles from "./Tooltip.module.scss";

export const Tooltip = (
    props: Immutable<{
        options: string;
        copy: string;
        ariaLabel: string;
        /** Use a non-button trigger when rendered inside another button. */
        nestedInFocusableAncestor?: boolean;
    }>,
): React.JSX.Element => {
    const icon = (
        <SVG
            aria-hidden="true"
            className={styles.icon}
            src={iconQuestionMarkCircle}
        />
    );

    return (
        <div className={styles.wrapper}>
            {props.options}
            <Popover.Root modal={true}>
                <Popover.Trigger
                    asChild
                    aria-expanded={undefined}
                    aria-controls={undefined}
                >
                    {props.nestedInFocusableAncestor ? (
                        <span
                            role="button"
                            tabIndex={0}
                            aria-label={props.ariaLabel}
                            className={styles.iconButton}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                            onKeyDown={(event) => {
                                event.stopPropagation();
                                if (
                                    event.key === "Enter" ||
                                    event.key === " "
                                ) {
                                    event.preventDefault();
                                    event.currentTarget.click();
                                }
                            }}
                        >
                            {icon}
                        </span>
                    ) : (
                        <button
                            type="button"
                            aria-label={props.ariaLabel}
                            className={styles.iconButton}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                        >
                            {icon}
                        </button>
                    )}
                </Popover.Trigger>
                <Popover.Portal>
                    <Popover.Content
                        className={styles.tooltip}
                        sideOffset={5}
                        style={{ zIndex: 30000 }}
                        aria-label={props.ariaLabel}
                        aria-modal={true}
                    >
                        <span className={styles.content}>{props.copy}</span>
                        <Popover.Close
                            type="button"
                            className={styles.closeButton}
                            aria-label={t`Close`}
                        >
                            <SVG src={iconXClose} aria-hidden="true" />
                        </Popover.Close>
                        <Popover.Arrow />
                    </Popover.Content>
                </Popover.Portal>
            </Popover.Root>
        </div>
    );
};
